const styles = {
  button: {
    height: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    borderRadius: '50px!important',
    mb: 1,
    '&.MuiButton-outlined': {
      borderColor: (theme) => `${theme.palette.background.black}!important`,
      backgroundColor: 'background.grey300',
    },
    '&.MuiButton-outlined:hover': {
      backgroundColor: (theme) => `${theme.palette.background.grey300}!important`,
      borderColor: (theme) => `${theme.palette.primary.main}!important`,
      color: (theme) => `${theme.palette.primary.main}!important`,
    },
  },
}

export default styles
